import React, {useCallback} from 'react';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Indentation from '../../../components/Simple/Indentation';
import SMCFileInput from '../../../components/Simple/SMCFileInput';
import {SMCRadioGroup, SMCRadio} from '../../../components/Simple/SMCRadio';
import {CertificateHandlingValues} from '.';
import RowLayout from '../../../components/Layouts/RowLayout';
import {SMCSelect, SMCOption} from '../../../components/Simple/SMCSelect';

function ImportSMPStepOne({
    onCancel,
    onNext,
    pageParams
}) {
    const { t } = useTranslation();

    const {
        availableDomains,
        fileToImport, setFileToImport,
        doOverrideExistingData, setDoOverrideExistingData,
        certificateHandling, setCertificateHandling,
        doImportIntoAllDomains, setDoImportIntoAllDomains,
        domainToImportTo, setDomainToImportTo
    } = pageParams;

    const handleNext = useCallback(() => {
        if (!fileToImport) {
            alert(t('SMC_SYSOPS_IMPWIZ_NO_INPUT'));
        } else {
            onNext();
        }
    }, [fileToImport, onNext, t]);

    return (
        <>
        <SMCModalBody>
            <SMCLabel bold fontSize="16px">{t('SMC_SYSOPS_IMPWIZ_TEXT')}</SMCLabel>
            <Indentation indentation="10px">
                <RowLayout spacing="4px">
                    <SMCLabel>
                        {t('SMC_SYSOPS_IMPWIZ_FILE')}
                    </SMCLabel>
                    <SMCFileInput
                        accept=".xml"  
                        onChange={fileList => {
                            if (fileList && fileList.length) {
                                setFileToImport(fileList[0]);
                            } else {
                                setFileToImport(undefined);
                            }
                        }}
                    />
                </RowLayout>
                <SMCLabel bold>{t('SMC_SYSOPS_IMPWIZ_OPS')}</SMCLabel>
                <Indentation>
                    <SMCRadioGroup value={doOverrideExistingData} onChange={e => setDoOverrideExistingData(e.target.value === 'true')}>
                        <SMCRadio value={false} label={t('SMC_SYSOPS_IMPWIZ_ADD')} />
                        <SMCRadio value={true} label={t('SMC_SYSOPS_IMPWIZ_REPLACE')} />
                    </SMCRadioGroup>
                </Indentation>
                <SMCLabel bold>{t('SMC_SYSOPS_IMPWIZ_CERT_HANDLING')}</SMCLabel>
                <Indentation>
                    <SMCRadioGroup disabled={!doOverrideExistingData} value={certificateHandling} onChange={e => setCertificateHandling(e.target.value)}>
                        <SMCRadio value={CertificateHandlingValues.retain} label={t('SMC_SYSOPS_IMPWIZ_RETAIN_CERTS')} tooltip={t('SMC_SYSOPS_IMPWIZ_RETAIN_CERTS_TOOLTIP')} />
                        <SMCRadio value={CertificateHandlingValues.import} label={t('SMC_SYSOPS_IMPWIZ_IMPORT_CERTS')} tooltip={t('SMC_SYSOPS_IMPWIZ_IMPORT_CERTS_TOOLTIP')} />
                        <SMCRadio value={CertificateHandlingValues.revoke} label={t('SMC_SYSOPS_IMPWIZ_REVOKE_CERTS')} tooltip={t('SMC_SYSOPS_IMPWIZ_REVOKE_CERTS_TOOLTIP')} />
                    </SMCRadioGroup>
                </Indentation>
                <SMCLabel bold>{t('SMC_SYSOPS_IMPWIZ_PORTAL_TEXT')}</SMCLabel>
                <Indentation>
                    <SMCRadioGroup value={doImportIntoAllDomains} onChange={e => setDoImportIntoAllDomains(e.target.value === 'true')}>
                        <SMCRadio value={true} label={t('SMC_SYSOPS_IMPWIZ_ALLPORTALS')} tooltip={t('SMC_SYSOPS_IMPWIZ_ALLPORTALS_TOOLTIP')} />
                        <RowLayout spacing="4px">
                            <SMCRadio value={false} label={t('SMC_SYSOPS_EXPWIZ_PORTAL_SELECT')} tooltip={t('SMC_SYSOPS_IMPWIZ_PORTAL_SELECT_TOOLTIP')} />
                            <SMCSelect disabled={doImportIntoAllDomains} value={domainToImportTo} onChange={e => setDomainToImportTo(e.target.value)}>
                                { availableDomains && availableDomains.map(domain => <SMCOption value={domain} key={domain}>{domain}</SMCOption>) }
                            </SMCSelect>
                        </RowLayout>
                    </SMCRadioGroup>
                </Indentation>
            </Indentation>
        </SMCModalBody>
        <SMCModalButtonContainer>
            <SMCButton onClick={handleNext}>
                {t('SMC_GEN_WIZNEXT')}
                <FontAwesomeIcon style={{ marginTop: '3px', marginLeft: '5px' }} color="grey" icon="arrow-circle-right" />
            </SMCButton>
            <SMCButton onClick={onCancel}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                {t('SMC_GEN_CANCEL')}
            </SMCButton>
        </SMCModalButtonContainer>
        </>
    )
}

export default ImportSMPStepOne;